'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowFriendbuyWidget = exports.ShowFriendbuyWidgetUnwrapped = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _FriendbuyWidget = require('components/Friendbuy/FriendbuyWidget');

var _decorator = require('helpers/decorator');

var _verify = require('helpers/verify');

var _deep = require('helpers/deep');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ref = _bound.userProfile.data(state) || ownProps.user || {},
      rafInfo = _ref.friendbuy_info,
      id = _ref.id,
      email = _ref.email,
      msa = _ref.msa;

  return {
    email: email,
    loaded: !(0, _verify.isEmpty)(rafInfo),
    userId: id,
    countryCode: (0, _deep.deepExtract)('country_code', msa, 'USA'),
    widgetCode: rafInfo && rafInfo.widget_code
  };
};

var ShowFriendbuyWidgetUnwrapped = exports.ShowFriendbuyWidgetUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ShowFriendbuyWidgetUnwrapped, _PureComponent);

  function ShowFriendbuyWidgetUnwrapped() {
    var _ref2;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, ShowFriendbuyWidgetUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ShowFriendbuyWidgetUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ShowFriendbuyWidgetUnwrapped)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = { open: false }, _this2.handleClick = function (e) {
      e.stopPropagation();
      var onClick = _this.props.onClick;

      _this.setState({ open: true });

      if (onClick) {
        onClick();
      }
    }, _this2.handleFriendbuyWidgetClose = function () {
      return _this.setState({ open: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(ShowFriendbuyWidgetUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          email = _props.email,
          intl = _props.intl,
          loaded = _props.loaded,
          userId = _props.userId,
          countryCode = _props.countryCode,
          widgetCode = _props.widgetCode;


      return loaded && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'a',
          {
            className: className,
            onClick: this.handleClick
          },
          children
        ),
        this.state.open && _react2.default.createElement(_FriendbuyWidget.FriendbuyWidget, {
          countryCode: countryCode,
          userId: userId,
          email: email,
          intl: intl,
          widgetCode: widgetCode,
          onClose: this.handleFriendbuyWidgetClose
        })
      );
    }
  }]);
  return ShowFriendbuyWidgetUnwrapped;
}(_react.PureComponent);

ShowFriendbuyWidgetUnwrapped.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  email: _propTypes2.default.string,
  intl: _reactIntl.intlShape,
  loaded: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func,
  userId: _propTypes2.default.number,
  countryCode: _propTypes2.default.string,
  widgetCode: _propTypes2.default.string
};

var ShowFriendbuyWidget = exports.ShowFriendbuyWidget = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), _reactIntl.injectIntl)(ShowFriendbuyWidgetUnwrapped);